import { render, staticRenderFns } from "./TopicIndex.vue?vue&type=template&id=643cdb91&"
import script from "./TopicIndex.vue?vue&type=script&lang=js&"
export * from "./TopicIndex.vue?vue&type=script&lang=js&"
import style0 from "./TopicIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports